import { EditorActions, EditorActionType } from 'dashboard/redux/actions/editor';

export interface EditorState {
  locale?: string;
  selectedTemplateId?: string;
}

const initialEditorState: EditorState = {
  locale: 'en-US',
};

export default (state: EditorState = initialEditorState, action: EditorActions) => {
  switch (action.type) {
    case EditorActionType.SetLocale: {
      return {
        ...state,
        locale: action.payload.locale,
      };
    }

    case EditorActionType.SetSelectedTemplateId: {
      return {
        ...state,
        selectedTemplateId: action.payload.selectedTemplateId,
      };
    }

    default:
      return state;
  }
};
